<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication also">Talking with Serial Killers: World’s Most Evil <br/><span class="no-style-override-4">is dedicated to my lovely wife Tatiana</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f005.vue?041790f0